/**
 * 编辑页附加信息
 * created by lzy 2020/07/06
 */
'use strict';
angular
    .module('editPageAppendixUploadModule', [])
    .directive('editPageAppendixUpload', [
        '$q',
        'Upload',
        'modalDialog',
        'trsFileService',
        'loginService',
        'globleParamsSet',
        'trsHttpService',
        function($q, Upload, modalDialog, trsFileService, loginService, globleParamsSet, trsHttpService) {
            return {
                scope: true, // 继承作用域
                restrict: 'EA',
                templateUrl: './editingCenter/directive/editPagePart/appendixUpload/appendixUpload.html',
                replace: true,
                link: function($scope) {
                    initStatus();
                    initData();

                    /**
                     * [initStatus description]初始化
                     *
                     * @return  {[type]}  [return description]
                     */
                    function initStatus() {
                    }

                    /**
                     * [initData description] 初始化数据
                     *
                     * @return  {[type]}   [return description]
                     */
                    function initData() {
                    }

                    /**
                     * [getUserInfo description]获取用户信息以及token
                     * @return  {[type]}  [return description]
                     */
                    function getUserInfo() {
                        var defer = $q.defer();
                        if ($scope.appendixUpload.options.needToken) {
                            loginService.getCurrLoginUser().then(function (user) {
                                if ($scope.appendixUpload.options.needToken === 'newest') { // 共享稿库-通讯员稿库-退稿功能上传附件时，后端token设置的五分钟过期，所以每次上传时重新请求token
                                    return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), {
                                        serviceid: 'getToken',
                                        tenantId: user.TENANTID,
                                    }, 'get').then(function (data) {
                                        return data;
                                    });
                                } else {
                                    return globleParamsSet.getTokenService(user.TENANTID);
                                }
                            }).then(function (tokenInfo) {
                                $scope.token = tokenInfo.token;
                                defer.resolve();
                            });
                        } else {
                            defer.resolve();
                        }
                        return defer.promise;
                    }

                    /**
                     * [upload description]文件上传事件
                     *
                     * @param  {[type]}  files   [files description]
                     *
                     * @return  {[type]}   [return description]
                     */
                    $scope.extrasUpload = function(files) {
                        if (!files || !files.length) {
                            return;
                        }
                        if (!$scope.appendixUpload.fileList) {
                            $scope.appendixUpload.fileList = [];
                        }
                        if (files && files.length + $scope.appendixUpload.fileList.length > $scope.appendixUpload.options.maxCount) {
                            modalDialog.alertType('文件上传的数量不可超过' + $scope.appendixUpload.options.maxCount + '个', '', 'error', false);
                            return;
                        }
                        getUserInfo().then(function() {
                            for (var i = 0; i < files.length; i++) {
                                if (!isFineFile(files[i].name)) {
                                    modalDialog.alertType('请检查文件类型', '', 'error', false);
                                    return;
                                }
                                if (parseInt($scope.appendixUpload.options.maxSize) * Math.pow(1024, 2) < files[i].size) {
                                    modalDialog.alertType('上传文件的单个大小不可超过' + $scope.appendixUpload.options.maxSize + 'MB', '', 'error', false);
                                    return;
                                }
                                var file = {
                                    FileName: files[i].name,
                                    FILEINFO: '正在上传',
                                    // FileDesc: files[i].name.substring(0, files[i].name.lastIndexOf('.')),
                                    FileSize: files[i].size,
                                    file: files[i],
                                };
                                $scope.appendixUpload.fileList.push(file);
                                uploadFile(file);
                            }
                        });
                    };

                    /**
                     * [uploadAgain description] 重新上传
                     *
                     * @param  {[type]}  file   [file description]
                     * @param  {[type]}  index   [file description]
                     *
                     * @return  {[type]}   [return description]
                     */
                    $scope.extrasUploadAgain = function(file, index) {
                        file.FILEINFO = '正在上传';
                        uploadFile(file);
                    };
                    
                    /**
                     * [getFileIcon 获取文件类型iconfont]
                     *
                     * @param   {[type]}  name  [name description]
                     *
                     * @return  {[type]}        [return description]
                     */
                    $scope.getFileIcon = function(name) {
                        return trsFileService.getFileIcon(name);
                    };
                
                    /**
                     * [getFileReplace 获取文件占位符]
                     *
                     * @param   {[type]}  name  [name description]
                     *
                     * @return  {[type]}        [return description]
                     */
                    $scope.getFileReplace = function(name) {
                        return trsFileService.getFileIconImg(name);
                    };

                    /**
                     * [isFineFile description]上传文件前检查格式
                     *
                     * @param   {[type]}  filepath  [filepath description]
                     *
                     * @return  {[type]}            [return description]
                     */
                    function isFineFile(filepath) {
                        let extStart = filepath.lastIndexOf('.');
                        let ext = filepath.substring(extStart, filepath.length).toLowerCase();
                        if (/\.(gif|jpg|jpeg|png|doc|docx|pptx|xls|xlsx|pdf|mp4|mov|mp3|flv|rar|zip|gz|winzip|z|7z)$/.test(ext)) {
                            return true;
                        }
                        return false;
                    }

                    /**
                     * [uploadFile description] 附件上传方法
                     *
                     * @param  {[type]}  file   [file description]
                     * @param  {[type]}  fileObj   [file description]
                     *
                     * @return  {[type]}   [return description]
                     */
                    function uploadFile(file) {
                        if (file.FILEINFO === '正在上传') {
                            Upload.upload({
                                url: $scope.appendixUpload.options.uploadUrl,
                                data: {
                                    file: file.file,
                                },
                                headers: {
                                    token: $scope.token
                                }
                            }).then(
                                function(resp) {
                                    $scope.fileUploadSuccess(resp, file);
                                },
                                function(resp) {
                                    $scope.fileUploadFail(resp, file);
                                   
                                },
                                function(evt) {
                                    file.icon = $scope.getFileReplace(file.FileName);
                                    $scope.fileUploadProgress(evt, file);
                                }
                            );
                        }
                    }

                    /**
                     * [delete description] 删除文件方法
                     *
                     * @param  {[type]}  index   [index description]
                     *
                     * @return  {[type]}   [return description]
                     */
                    $scope.extrasDelete = function(index) {
                        // $scope.extrasFilesArr.splice(index, 1);
                        $scope.appendixUpload.fileList.splice(index, 1);
                    };

                    /**
                     * [move description] 文件位置移动方法
                     *
                     * @param  {[type]}  index   [index description] 原来位置
                     * @param  {[type]}  targetIndex   [targetIndex description] 目标位置
                     *
                     * @return  {[type]}   [return description]
                     */
                    $scope.extrasMove = function(index, targetIndex) {
                        $scope.appendixUpload.fileList[index] = $scope.appendixUpload.fileList.splice(targetIndex, 1, $scope.appendixUpload.fileList[index])[0];
                    };

                    /**
                     * [checkTheFile description] 检查所有文件是否上传完成
                     *
                     * @return  {[type]}   [return description]
                     */
                    $scope.extrasCheckTheFileSuccess = function() {
                        if ($scope.status.isFusionEditor) {
                            return true;
                        }
                        for (var i = 0; i < $scope.appendixUpload.fileList.length; i++) {
                            var file = $scope.appendixUpload.fileList[i];
                            if (file.FILEINFO === '正在上传' || file.FILEINFO === '上传失败') {
                                modalDialog.alertType('还有文件正在上传或上传失败', '', 'warning', false);
                                return false;
                            }
                        }
                        return true;
                    };

                    // 将判断是否上传完成的方法绑定在父组件上，可以直接在父组件上调用
                    if (!$scope.$parent.extrasCheckTheFileSuccess) {
                        $scope.$parent.extrasCheckTheFileSuccess = $scope.extrasCheckTheFileSuccess;
                    }
                },
            };
        },
    ])
    .filter('truncatedString', function() {
        return function(str) {
            if (!str) {
                return '';
            }
            var arr = str.split('.');
            var type = arr.pop();
            var name = arr.join('.');
            if (name.length > 13) {
                return name.substr(0, 11) + '...' + name.slice(-2) + '.' + type;
            }
            return str;
        };
    });
